import {setCssVariable, useDisplayMobile} from '@malt/utils';
import {ref, watch, onUnmounted, computed} from 'vue';
import {storeToRefs} from 'pinia';
import {NavBarWidth} from '../aside-menu.types';
import {useDisplayMode} from '../stores/display-mode.store';
import {navbarEventBus} from '@navbar/events';
import {useUser} from '@navbar-logged/features/user';

export function useMobileNavBar() {
    const {isDisplayMobile} = useDisplayMobile();
    const displayModeStore = useDisplayMode();
    const userStore = useUser();
    const {selectedIdentity, hasSelectedClientIdentity} = storeToRefs(userStore);

    const isMobileNavBarOpened = ref(false);
    const serviceLevel = computed(() => selectedIdentity.value?.serviceLevel);

    let timeoutCssSetter: NodeJS.Timeout | null = null;

    function onDisplayMobileChange(state: boolean) {
        if (import.meta.client) {
            if (timeoutCssSetter) {
                clearTimeout(timeoutCssSetter);
            }
            if (state) {
                setCssVariable('--aside-menu-left', '-100%');
                setCssVariable('--layout-padding-left', '0px');
                timeoutCssSetter = setTimeout(() => {
                    setCssVariable('--aside-menu-width', `${NavBarWidth.Mobile}px`);
                }, 300);
            } else {
                isMobileNavBarOpened.value = false;
                displayModeStore.setNavbarDisplayMode({savePreference: false});
                setCssVariable('--aside-menu-left', '0px');
            }
        }
    }

    function setMobileNavBarOpened(value: boolean) {
        if (value) {
            isMobileNavBarOpened.value = true;
            setCssVariable('--aside-menu-left', '0px');
        } else {
            isMobileNavBarOpened.value = false;
            setCssVariable('--aside-menu-left', '-100%');
        }
    }

    function toggleMobileNavBarOpened() {
        setMobileNavBarOpened(!isMobileNavBarOpened.value);
    }

    watch(isDisplayMobile, onDisplayMobileChange, {immediate: true});

    watch(isMobileNavBarOpened, () => {
        if (hasSelectedClientIdentity.value && serviceLevel.value !== 'STANDARD') {
            navbarEventBus.emit('request:navbar-toggle-on-mobile', {isOpen: isMobileNavBarOpened.value});
        }
    });

    onUnmounted(() => navbarEventBus.off('request:navbar-toggle-on-mobile'));

    return {
        toggleMobileNavBarOpened,
        setMobileNavBarOpened,
        isMobileNavBarOpened,
    };
}
